import { schemes, zSchema } from "@zeal/common";

export const getAccrualUsagePeriodHintsRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  employee_id: schemes.mongoOrUuid(),
  policy_id: schemes.mongoOrUuid(),
});

export type TGetAccrualUsagePeriodHintsRequestSchema = zSchema.infer<
  typeof getAccrualUsagePeriodHintsRequestSchema
>;

export const accrualUsagePeriodHintSchema = zSchema.object({
  start_date: zSchema.string(),
  end_date: zSchema.string(),
  label: zSchema.string(),
});

export const getAccrualUsagePeriodHintsResponseSchema = zSchema.object({
  periods: zSchema.array(accrualUsagePeriodHintSchema),
});

export type TGetAccrualUsagePeriodHintsResponseSchema = zSchema.infer<
  typeof getAccrualUsagePeriodHintsResponseSchema
>;
